import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
// import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import ListingProvider from './contexts/ListingContext';

import 'react-toastify/dist/ReactToastify.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EventProvider from './contexts/EventContext';
import { useSelector } from 'react-redux';
import CompanyProvider from './contexts/CompanyContext';
import NotificationProvider from './contexts/notificationContent';

// ----------------------------------------------------------------------

export default function App() {
  const user = useSelector((state) => state.user.user);

  // const [role, setRole] = useState('')
  // window.location.reload('/dashboard/app')
  // useEffect(()=>{
  //   const storedUser = JSON.parse(localStorage.getItem('_pildat'));
  //  const userRole = storedUser?.role; // Handle potential nullish value
  //  setRole(userRole)
  // },[])

  return (
    <>
      {/* <div style={{ position: 'fixed', backgroundColor: '#80808036', zIndex: 9800, bottom: 0, textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px 0px' }}><p style={{ padding: 0, margin: 0, color: 'rgb(33 32 32)', display: 'flex', alignItems: 'center', fontSize: 12 }}>Powered By <img style={{ height: 25, marginRight: 6 }} src="/assets/images/webseowiz-logo.png" /> Webseowiz Tech</p></div> */}
      <HelmetProvider>
        <NotificationProvider>
          <ListingProvider>
            <EventProvider>
              <CompanyProvider>
                <BrowserRouter>
                  <ThemeProvider>
                    <ScrollToTop />
                    <StyledChart />
                    {/* <div style={{position:'fixed',backgroundColor:'#80808036',zIndex:9800,bottom:0,textAlign:'center',width:'100%',display:'flex',alignItems:'center', justifyContent:'center'}}><img style={{height:25,marginRight:15}} src="/assets/images/webseowiz-logo.png" /><p style={{padding:0,margin:0,color:'rgb(33 32 32)',fontSize:12}}>Powered By Webseowiz Tech</p></div> */}
                    <Router role={user?.role || ''} />
                    <ToastContainer position="bottom-right"
                      autoClose={3000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light" />
                  </ThemeProvider>
                </BrowserRouter>
              </CompanyProvider>
            </EventProvider>
          </ListingProvider>
        </NotificationProvider>
      </HelmetProvider>
    </>
  );
}
